import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const smartThings = defineConnector({
  identifier: "smartThings",
  name: "SmartThings",
  tagLine: "Samsung smart home platform",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.smartthings\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "Go to https://account.smartthings.com/tokens and generate a new token, granting at least the “r:locations:*” and “r:devices:*” permissions. Copy the token immediately, because it’s shown only once. Note that personal access tokens created after 30 December 2024 expire 24 hours after creation, so for long-running use you’ll need to refresh the token regularly.",
        },
      ],
    },
    {
      title: "Paste your personal access token below",
      items: [
        {
          kind: "input",
          label: "SmartThings personal access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.smartthings.com/v1/locations",
  },
});
